module.exports = __webpack_public_path__ + "img/logo.72c0599e.png";